import React from "react";
import { useSelector } from "react-redux";
import { pdpOutOfStockSelector, pdpStockSelector } from "../../selectors/pdp";
import { PrimaryButton } from "../../elements";
import { getOverallSettingsStyles } from "../../utils/siteUtils";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import "./style.scss";

const PdpOutofStockBanner = ({ fields }) => {
  /*Redux start*/
  const pdpStock = useSelector(pdpStockSelector);
  const pdpOutofStock = useSelector(pdpOutOfStockSelector);
  /*Redux end*/
  const { headingType, headingBody, body, buttonCTA } = fields;
  const overallSettingStyle = getOverallSettingsStyles(fields);
  const rootProps = {
    className: "pdp-out-of-stock-banner grid",
    style: overallSettingStyle
  };
  const btnProps = {
    ...buttonCTA.fields
  };
  if (pdpOutofStock) {
    return (
      <div {...rootProps}>
        <div className="pdp-out-of-stock-banner__content">
          <div className="text-wrapper">
            <Heading type={headingType} html={headingBody} />
            <BodyText html={body} />
          </div>
          <PrimaryButton {...btnProps} />
        </div>
      </div>
    );
  } else {
    return null;
  }
};
export default PdpOutofStockBanner;
